module.exports = {
	"dk-ui-lib": {
		"header": {
			"settings": "SETTINGS",
			"manageAdmins": "MANAGE ADMINS"
		},
		"nav_menu": {
			"user_settings_submenu": {
				"change_password": "CHANGE PASSWORD",
				"logout": "LOGOUT"
			}
		},
		"login": {
			"email": "REGISTERED EMAIL ID",
			"password": "PASSWORD",
			"login": "LOGIN",
			"forgotPassword": "FORGOT PASSWORD?",
			"recover_password": "Recover Password",
			"enter_email_id": "Enter your Email ID",
			"to_login": "To Login",
			"click_here": "Click Here",
			"link_mailed": "Password Recovery Link Mailed",
			"recover_password_desk_1": "We have mailed instructions to set a new password for your account to",
			"recover_password_desk_2": "Please check your email to continue. Check your spam folder if you do not receive a mail in your inbox"
		},
		"profile": {
			"changePassword": {
				"changePassword": "CHANGE PASSWORD",
				"currentPassword": "CURRENT PASSWORD",
				"newPassword": "NEW PASSWORD",
				"confirmNewPassword": "CONFIRM NEW PASSWORD",
				"save": "SAVE",
				"valid": {
					"password": "VALID PASSWORD",
					"match": "PASSWORDS MATCH"
				},
				"passwordCriteria": {
					"line-1": "Make sure password has -",
					"line-2": "Alphabets and numbers ",
					"line-3": "Upper and lower case letters",
					"min-max_characters": "5 to 15 characters",
					"letter": "at least 1 letter",
					"number": "at least 1 number",
					"special_character": "at least 1 special character"
				}
			}
		},
		"dashboard": {
			"scheduled": "SCHEDULED",
			"completed": "COMPLETED",
			"sessions": "SESSIONS",
			"candidates": "CANDIDATES",
			"registered": "REGISTERED",
			"create": "CREATE",
			"schedule": "SCHEDULE",
			"session_tracking": "SESSION TRACKING",
			"performance_tracking": "PERFORMANCE TRACKING",
			"see_all": "SEE ALL",
			"view_key": "VIEW KEY",
			"key": "KEY"
		},
		"academy": {
			"onboard": {
				"message": "JUST A FEW THINGS BEFORE YOU GO IN",
				"set_password": "SET A PASSWORD",
				"confirm_institution_details": "CONFIRM INSTITUTION DETAILS",
				"warning_message": "In case of discrepency, Please contact our admin.",
				"name": "NAME",
				"wrong_ingo": "Wrong Info",
				"id": "ACADEMY ID",
				"location": "LOCATION",
				"create_login": "CREATE LOGIN",
				"login_name": "NAME",
				"login_email": "EMAIL ID",
				"done": "DONE",
				"hello": "HELLO"
			},
			"candidates": {
				"your_academy": "YOUR ACADEMY",
				"add_batches_and_upload_candidates": "ADD BATCHES AND UPLOAD CANDIDATES",
				"degree": "DEGREE",
				"branch": "BRANCH",
				"department": "DEPARTMENT",
				"year": "YEAR",
				"year_of_passing": "YEAR OF PASSING",
				"candidates": "CANDIDATES",
				"degree_placeholder": "Eg. B.E",
				"branch_placeholder": "Eg. CSE",
				"year_placeholder": "Eg. %{year}",
				"select_file": "SELECT FILE",
				"no_file_selected": "NO FILE SELECTED",
				"over_write": "OVERWRITE"
			}
		},
		"sessions": {
			"heading": "SCHEDULE DETAILS",
			"session_name": "SESSION NAME",
			"session": "SESSION",
			"date": "DATE",
			"time": "TIME",
			"catgory": "CATEGORY",
			"upload_student_list": "UPLOAD STUDENT LIST",
			"upload": "UPLOAD",
			"schedule": "SCHEDULE",
			"next": "NEXT",
			"successfully_scheduled_session": "SUCCESSFULLY SCHEDULED",
			"scheduled_candidates": "SCHEDULED FOR %{candidatesCount} CANDIDATES",
			"existing": "EXISTING",
			"new_candidates": "NEW CANDIDATES",
			"back_to_dashboard": "BACK TO DASHBOARD",
			"registered": "REGISTERED",
			"attended": "ATTENDED",
			"view": "VIEW",
			"performance": "PERFORMANCE",
			"candidates": "CANDIDATES",
			"selected": "SELECTED",
			"filters": {
				"filters": "FILTERS",
				"degree": "DEGREE",
				"pick_degree": "Pick Degree",
				"department": "DEPARTMENT",
				"pick_department": "Pick Department",
				"year_of_passing": "YEAR OF PASSING",
				"pick_year": "Pick Year",
				"view": "VIEW"
			},
			"results": "Results",
			"search": "SEARCH",
			"type_name": "Type Name",
			"zero_candidates_placeholder_message_line1": "USE THE",
			"and": "AND",
			"zero_candidates_placeholder_message_line2": "START SELECTING STUDENTS FOR THE ASSESSMENT",
			"selected_zero_candidates_placeholder_message_line1": "NO CANDIDATES SELECTED YET.",
			"selected_zero_candidates_placeholder_message_line2": "START SELECTING IN THE PREVIOUS TAB",
			"no_results_found": "No Results Found",
			"step1_of_2": "STEP 1 OF 2",
			"step2_of_2": "STEP 2 OF 2",
			"over_all": "OVER ALL",
			"assessment": "Assessment"
		},
		"license": {
			"assessments_used": "USED",
			"assessments_available": "AVAILABLE"
		},
		"reports": {
			"candidate_level": "CANDIDATE LEVEL",
			"skill": "SKILL",
			"skill_level": "SKILL LEVEL",
			"session_details": "SESSION DETAILS",
			"session_name": "SESSION NAME",
			"assessment_taken": "ASSESSMENT TAKEN",
			"carats": "CARATS",
			"scored": "SCORED",
			"total": "TOTAL",
			"peer_avg": "Peer Avg",
			"time_clocked": "TIME CLOCKED",
			"hrs": "HRS",
			"section": "SECTION",
			"programming": "PROGRAMMING",
			"questions": "QUESTIONS",
			"format": "FORMAT",
			"concepts_covered": "CONCEPTS COVERED",
			"concept_name": "CONCEPT NAME",
			"correctness": "CORRECTNESS",
			"speed": "SPEED",
			"time_complexity": "TIME COMPLEXITY",
			"obtained": "obtained",
			"expected": "expected",
			"problems_analysis": "PROBLEMS ANAYLSIS",
			"test_cases_solved": "TEST CASES SOLVED",
			"boundary": "BOUNDARY",
			"normal": "NORMAL",
			"invalid": "INVALID",
			"hard": "HARD",
			"mins": "MINS",
			"recommended": "RECOMMENDED",
			"code_quality": "CODE QUALITY",
			"mcq": "MCQ",
			"problem_info": "Problem Info",
			"report_not_available": "Report Not Available",
			"detailed_assessment_report": "DETAILED ASSESSMENT REPORT",
			"profile": {
				"roll_number": "ROLL NUMBER",
				"year_of_passing": "YEAR OF PASSING",
				"department": "DEPARTMENT",
				"criteria_score": "CRITERIA SCORE"
			},
			"personal_info": "PERSONAL INFO",
			"overall_earned": "OVERALL EARNED",
			"level": "LEVEL",
			"view_report": "VIEW REPORT",
			"download": "DOWNLOAD"
		},
		"candidates": {
			"socials": {
				"social_profiles": "SOCIAL PROFILES",
				"github": "Github",
				"stackoverflow": "Stackoverflow",
				"followers": "Followers",
				"stars": "Stars",
				"forks": "Forks",
				"repos": "Repos",
				"reputation": "Reputation",
				"questions": "Questions",
				"answers": "Answers",
				"badges": "Badges",
				"gold": "Gold",
				"silver": "Silver",
				"bronze": "Bronze"
			},
			"pet_projects": {
				"pet_projects": "PET PROJECTS",
				"pet_project": "PET PROJECT",
				"name": "NAME",
				"description": "DESCRIPTION",
				"skills": "SKILLS"
			}
		},
		"errors": {
			"login": {
				"email": "Please enter valid Email",
				"password": "Password is mandatory"
			},
			"profile": {
				"passwordMismatch": "PASSWORDS MISMATCH",
				"passwordCriteria": "PASSWORD DOES NOT MATCH CRITERIA"
			},
			"unexpected": "Unexpected error",
			"requiredFields": "Required Fields"
		},
		"buttons": {
			"submit": "SUBMIT",
			"done": "DONE",
			"next": "NEXT",
			"send_mail": "SEND EMAIL",
			"back_to_login": "BACK TO LOGIN",
			"delete": "DELETE",
			"cancel": "CANCEL"
		},
		"date": "DATE",
		"time": "TIME",
		"delete_confirmation_desc": "Are You Sure to Delete",
		"not_found": "Page not found",
		"not_allowed": "Not allowed"
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/i18n/locale/en.json
// module id = 1144
// module chunks = 0